import React from 'react';
import classNames from 'classnames';

import { CallBlock, TextBlock } from '@/ui/index';

import styles from './Advantageous.module.scss';

const Advantageous = ({ data }) => {
  return (
    <div>
      <div className={'wrapper small-margin'}>
        {data?.description && (
          <TextBlock className={classNames([styles.text, 'text--large'])}>
            {data.description}
          </TextBlock>
        )}
        <CallBlock numbers={data?.items} />
      </div>
    </div>
  );
};

export default Advantageous;
